/**
 * Client Form Dropdown Options
 * Static dropdown data for client registration
 */

export const GENDERS = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Others', label: 'Others' },
]

export const CIVIL_STATUS_OPTIONS = [
  { value: 'Single', label: 'Single' },
  { value: 'Married', label: 'Married' },
  { value: 'Widowed', label: 'Widowed' },
  { value: 'Divorced', label: 'Divorced' },
  { value: 'Legally Separated', label: 'Legally Separated' },
]

export const RELIGIONS = [
  { value: 'None', label: 'None' },
  { value: 'Islam', label: 'Islam' },
  { value: 'Roman Catholic Church', label: 'Roman Catholic Church' },
  { value: 'Iglesia ni Cristo (INC)', label: 'Iglesia ni Cristo (INC)' },
  { value: 'Philippine Independent Church (Aglipayan Church)', label: 'Philippine Independent Church (Aglipayan Church)' },
  { value: 'Members Church of God International (MCGI / Ang Dating Daan)', label: 'Members Church of God International (MCGI / Ang Dating Daan)' },
  { value: 'Jesus is Lord Church Worldwide', label: 'Jesus is Lord Church Worldwide' },
  { value: 'Jesus Miracle Crusade', label: 'Jesus Miracle Crusade' },
  { value: 'United Methodist Church', label: 'United Methodist Church' },
  { value: 'Baptist Churches', label: 'Baptist Churches' },
  { value: 'Assemblies of God', label: 'Assemblies of God' },
  { value: 'Foursquare Gospel Church', label: 'Foursquare Gospel Church' },
  { value: 'Presbyterian Church of the Philippines', label: 'Presbyterian Church of the Philippines' },
  { value: 'Lutheran Church in the Philippines', label: 'Lutheran Church in the Philippines' },
  { value: 'Anglican / Episcopal Church in the Philippines', label: 'Anglican / Episcopal Church in the Philippines' },
  { value: 'Seventh-day Adventist Church', label: 'Seventh-day Adventist Church' },
  { value: 'Pentecostal Missionary Church of Christ (4th Watch)', label: 'Pentecostal Missionary Church of Christ (4th Watch)' },
  { value: 'Victory Christian Fellowship', label: 'Victory Christian Fellowship' },
  { value: 'New Life Christian Center', label: 'New Life Christian Center' },
  { value: 'Bread of Life Ministries', label: 'Bread of Life Ministries' },
  { value: 'Church of Jesus Christ of Latter-day Saints', label: 'Church of Jesus Christ of Latter-day Saints' },
  { value: 'Others', label: 'Others (Please Specify)' },
]

export const EDUCATIONAL_ATTAINMENT = [
  { value: 'None', label: 'None' },
  { value: 'Preschool', label: 'Preschool' },
  // Elementary
  { value: 'Grade 1', label: 'Grade 1', group: 'Elementary' },
  { value: 'Grade 2', label: 'Grade 2', group: 'Elementary' },
  { value: 'Grade 3', label: 'Grade 3', group: 'Elementary' },
  { value: 'Grade 4', label: 'Grade 4', group: 'Elementary' },
  { value: 'Grade 5', label: 'Grade 5', group: 'Elementary' },
  { value: 'Grade 6', label: 'Grade 6', group: 'Elementary' },
  // Junior High School
  { value: 'Grade 7', label: 'Grade 7', group: 'Junior High School' },
  { value: 'Grade 8', label: 'Grade 8', group: 'Junior High School' },
  { value: 'Grade 9', label: 'Grade 9', group: 'Junior High School' },
  { value: 'Grade 10', label: 'Grade 10', group: 'Junior High School' },
  // Senior High School
  { value: 'Grade 11', label: 'Grade 11', group: 'Senior High School' },
  { value: 'Grade 12', label: 'Grade 12', group: 'Senior High School' },
  // Higher Education
  { value: 'Technical and Vocational Education and Training', label: 'Technical and Vocational Education and Training' },
  { value: 'Undergraduate', label: 'Undergraduate' },
]

export const INDIGENOUS_GROUPS = [
  { value: 'None', label: 'None' },
  { value: 'Adasen', label: 'Adasen' },
  { value: 'Abelling/Aborlin', label: 'Abelling/Aborlin' },
  { value: 'Aeta', label: 'Aeta' },
  { value: 'Abiyan', label: 'Abiyan' },
  { value: 'Agutaynon', label: 'Agutaynon' },
  { value: 'Agta', label: 'Agta' },
  { value: 'Agta-Tabangnon', label: 'Agta-Tabangnon' },
  { value: 'Agta-Cimaron', label: 'Agta-Cimaron' },
  { value: 'Alangan (Mangyan)', label: 'Alangan (Mangyan)' },
  { value: 'Applai', label: 'Applai' },
  { value: 'Ata-Matigsalog', label: 'Ata-Matigsalog' },
  { value: 'Ati', label: 'Ati' },
  { value: 'Arumanen', label: 'Arumanen' },
  { value: 'Ayangan', label: 'Ayangan' },
  { value: 'Binongan', label: 'Binongan' },
  { value: 'Bago', label: 'Bago' },
  { value: 'Bangon (Mangyan)', label: 'Bangon (Mangyan)' },
  { value: 'Bontok', label: 'Bontok' },
  { value: 'Balatoc', label: 'Balatoc' },
  { value: 'Baliwen', label: 'Baliwen' },
  { value: 'Baluga', label: 'Baluga' },
  { value: 'Batak', label: 'Batak' },
  { value: 'Batangan/Tao Buid', label: 'Batangan/Tao Buid' },
  { value: 'Buhid (Mangyan)', label: 'Buhid (Mangyan)' },
  { value: 'Balangao', label: 'Balangao' },
  { value: 'Bantoanon', label: 'Bantoanon' },
  { value: 'Bukidnon', label: 'Bukidnon' },
  { value: 'Badjao', label: 'Badjao' },
  { value: 'Banac', label: 'Banac' },
  { value: "B'laan", label: "B'laan" },
  { value: 'Bagobo', label: 'Bagobo' },
  { value: 'Banwaon', label: 'Banwaon' },
  { value: 'Calinga', label: 'Calinga' },
  { value: 'Cuyonon', label: 'Cuyonon' },
  { value: 'Camiguin', label: 'Camiguin' },
  { value: 'Danao', label: 'Danao' },
  { value: 'Dibabawon', label: 'Dibabawon' },
  { value: 'Dumagat', label: 'Dumagat' },
  { value: 'Eskaya', label: 'Eskaya' },
  { value: 'Gubang', label: 'Gubang' },
  { value: 'Gaddang', label: 'Gaddang' },
  { value: 'Giangan', label: 'Giangan' },
  { value: 'Guiangan-Clata', label: 'Guiangan-Clata' },
  { value: 'Gubatnon (Mangyan)', label: 'Gubatnon (Mangyan)' },
  { value: 'Hanunuo (Mangyan)', label: 'Hanunuo (Mangyan)' },
  { value: 'Hanglulo', label: 'Hanglulo' },
  { value: 'Higaonon', label: 'Higaonon' },
  { value: 'Itneg', label: 'Itneg' },
  { value: 'Inlaud', label: 'Inlaud' },
  { value: 'Ibaloi', label: 'Ibaloi' },
  { value: 'Ibanag', label: 'Ibanag' },
  { value: 'Itawes', label: 'Itawes' },
  { value: 'Ikalahan', label: 'Ikalahan' },
  { value: 'Ilongot/Bugkalot', label: 'Ilongot/Bugkalot' },
  { value: 'Isinai', label: 'Isinai' },
  { value: 'Isneg/Apayao', label: 'Isneg/Apayao' },
  { value: 'Iwak', label: 'Iwak' },
  { value: 'Iraya (Mangyan)', label: 'Iraya (Mangyan)' },
  { value: 'Itom', label: 'Itom' },
  { value: 'Ilianen', label: 'Ilianen' },
  { value: 'Ivatan', label: 'Ivatan' },
  { value: 'Kalinga', label: 'Kalinga' },
  { value: 'Kankanaey', label: 'Kankanaey' },
  { value: 'Kalanguya', label: 'Kalanguya' },
  { value: 'Kalibugan', label: 'Kalibugan' },
  { value: 'Kabihug', label: 'Kabihug' },
  { value: 'Kalagan', label: 'Kalagan' },
  { value: 'Karao', label: 'Karao' },
  { value: 'Kaylawan', label: 'Kaylawan' },
  { value: 'Kalamianen', label: 'Kalamianen' },
  { value: 'Langilan', label: 'Langilan' },
  { value: 'Masadiit', label: 'Masadiit' },
  { value: 'Maeng', label: 'Maeng' },
  { value: 'Mabaca', label: 'Mabaca' },
  { value: 'Malaueg', label: 'Malaueg' },
  { value: 'Magahat/Corolanos', label: 'Magahat/Corolanos' },
  { value: 'Manobo', label: 'Manobo' },
  { value: 'Manobo-Blit', label: 'Manobo-Blit' },
  { value: 'Mangguangan', label: 'Mangguangan' },
  { value: 'Mamanwa', label: 'Mamanwa' },
  { value: 'Mansaka', label: 'Mansaka' },
  { value: 'Matigsalog', label: 'Matigsalog' },
  { value: 'Mandaya', label: 'Mandaya' },
  { value: 'Molbog', label: 'Molbog' },
  { value: 'Pullon', label: 'Pullon' },
  { value: 'Palawanon', label: 'Palawanon' },
  { value: 'Remontado', label: 'Remontado' },
  { value: 'Ratagnon (Mangyan)', label: 'Ratagnon (Mangyan)' },
  { value: 'Sulod-Bukidnon', label: 'Sulod-Bukidnon' },
  { value: 'Sama-Badjao', label: 'Sama-Badjao' },
  { value: 'Sama-Bangingi', label: 'Sama-Bangingi' },
  { value: 'Sama/Kalibugan', label: 'Sama/Kalibugan' },
  { value: 'Subanen', label: 'Subanen' },
  { value: 'Sangil', label: 'Sangil' },
  { value: 'Tadyawan (Mangyan)', label: 'Tadyawan (Mangyan)' },
  { value: 'Tagabawa', label: 'Tagabawa' },
  { value: 'Tagbanwa', label: 'Tagbanwa' },
  { value: 'Tagakaolo', label: 'Tagakaolo' },
  { value: 'Talaandig', label: 'Talaandig' },
  { value: 'Talaingod', label: 'Talaingod' },
  { value: "T'boli", label: "T'boli" },
  { value: "Tao't Bato", label: "Tao't Bato" },
  { value: 'Tasaday', label: 'Tasaday' },
  { value: 'Tigwayanon', label: 'Tigwayanon' },
  { value: 'Tingguian', label: 'Tingguian' },
  { value: 'Tiruray/Teduray', label: 'Tiruray/Teduray' },
  { value: 'Tuwali', label: 'Tuwali' },
  { value: 'Umayamnon', label: 'Umayamnon' },
  { value: 'Ubo', label: 'Ubo' },
  { value: 'Yogad', label: 'Yogad' },
  { value: 'Others', label: 'Others (Please Specify)' },
]

// Citizenship list (195 countries)
export const CITIZENSHIPS = [
  { value: 'Filipino', label: 'Filipino / Filipina (Philippines)' },
  { value: 'Afghan', label: 'Afghan (Afghanistan)' },
  { value: 'Albanian', label: 'Albanian (Albania)' },
  { value: 'Algerian', label: 'Algerian (Algeria)' },
  { value: 'Andorran', label: 'Andorran (Andorra)' },
  { value: 'Angolan', label: 'Angolan (Angola)' },
  { value: 'Antiguan or Barbudan', label: 'Antiguan or Barbudan (Antigua and Barbuda)' },
  { value: 'Argentinian', label: 'Argentinian (Argentina)' },
  { value: 'Armenian', label: 'Armenian (Armenia)' },
  { value: 'Australian', label: 'Australian (Australia)' },
  { value: 'Austrian', label: 'Austrian (Austria)' },
  { value: 'Azerbaijani', label: 'Azerbaijani (Azerbaijan)' },
  { value: 'Bahamian', label: 'Bahamian (Bahamas)' },
  { value: 'Bahraini', label: 'Bahraini (Bahrain)' },
  { value: 'Bangladeshi', label: 'Bangladeshi (Bangladesh)' },
  { value: 'Barbadian', label: 'Barbadian (Barbados)' },
  { value: 'Belarusian', label: 'Belarusian (Belarus)' },
  { value: 'Belgian', label: 'Belgian (Belgium)' },
  { value: 'Belizean', label: 'Belizean (Belize)' },
  { value: 'Beninese', label: 'Beninese (Benin)' },
  { value: 'Bhutanese', label: 'Bhutanese (Bhutan)' },
  { value: 'Bolivian', label: 'Bolivian (Bolivia)' },
  { value: 'Bosnian or Herzegovinian', label: 'Bosnian or Herzegovinian (Bosnia and Herzegovina)' },
  { value: 'Motswana', label: 'Motswana / Batswana (Botswana)' },
  { value: 'Brazilian', label: 'Brazilian (Brazil)' },
  { value: 'Bruneian', label: 'Bruneian (Brunei)' },
  { value: 'Bulgarian', label: 'Bulgarian (Bulgaria)' },
  { value: 'Burkinabé', label: 'Burkinabé (Burkina Faso)' },
  { value: 'Burundian', label: 'Burundian (Burundi)' },
  { value: 'Cape Verdean', label: 'Cape Verdean (Cabo Verde)' },
  { value: 'Cambodian', label: 'Cambodian (Cambodia)' },
  { value: 'Cameroonian', label: 'Cameroonian (Cameroon)' },
  { value: 'Canadian', label: 'Canadian (Canada)' },
  { value: 'Central African', label: 'Central African (Central African Republic)' },
  { value: 'Chadian', label: 'Chadian (Chad)' },
  { value: 'Chilean', label: 'Chilean (Chile)' },
  { value: 'Chinese', label: 'Chinese (China)' },
  { value: 'Colombian', label: 'Colombian (Colombia)' },
  { value: 'Comoran', label: 'Comoran (Comoros)' },
  { value: 'Congolese', label: 'Congolese (Congo)' },
  { value: 'Costa Rican', label: 'Costa Rican (Costa Rica)' },
  { value: 'Ivorian', label: "Ivorian (Côte d'Ivoire)" },
  { value: 'Croatian', label: 'Croatian (Croatia)' },
  { value: 'Cuban', label: 'Cuban (Cuba)' },
  { value: 'Cypriot', label: 'Cypriot (Cyprus)' },
  { value: 'Czech', label: 'Czech (Czechia)' },
  { value: 'Danish', label: 'Danish (Denmark)' },
  { value: 'Djiboutian', label: 'Djiboutian (Djibouti)' },
  { value: 'Dominican', label: 'Dominican (Dominica / Dominican Republic)' },
  { value: 'Ecuadorian', label: 'Ecuadorian (Ecuador)' },
  { value: 'Egyptian', label: 'Egyptian (Egypt)' },
  { value: 'Salvadoran', label: 'Salvadoran (El Salvador)' },
  { value: 'Equatoguinean', label: 'Equatoguinean (Equatorial Guinea)' },
  { value: 'Eritrean', label: 'Eritrean (Eritrea)' },
  { value: 'Estonian', label: 'Estonian (Estonia)' },
  { value: 'Swazi', label: 'Swazi (Eswatini)' },
  { value: 'Ethiopian', label: 'Ethiopian (Ethiopia)' },
  { value: 'Micronesian', label: 'Micronesian (Micronesia)' },
  { value: 'Fijian', label: 'Fijian (Fiji)' },
  { value: 'Finnish', label: 'Finnish (Finland)' },
  { value: 'French', label: 'French (France)' },
  { value: 'Gabonese', label: 'Gabonese (Gabon)' },
  { value: 'Gambian', label: 'Gambian (Gambia)' },
  { value: 'Georgian', label: 'Georgian (Georgia)' },
  { value: 'German', label: 'German (Germany)' },
  { value: 'Ghanaian', label: 'Ghanaian (Ghana)' },
  { value: 'Greek', label: 'Greek (Greece)' },
  { value: 'Grenadian', label: 'Grenadian (Grenada)' },
  { value: 'Guatemalan', label: 'Guatemalan (Guatemala)' },
  { value: 'Guinean', label: 'Guinean (Guinea)' },
  { value: 'Bissau-Guinean', label: 'Bissau-Guinean (Guinea-Bissau)' },
  { value: 'Guyanese', label: 'Guyanese (Guyana)' },
  { value: 'Haitian', label: 'Haitian (Haiti)' },
  { value: 'Honduran', label: 'Honduran (Honduras)' },
  { value: 'Hungarian', label: 'Hungarian (Hungary)' },
  { value: 'Icelander', label: 'Icelander (Iceland)' },
  { value: 'Indian', label: 'Indian (India)' },
  { value: 'Indonesian', label: 'Indonesian (Indonesia)' },
  { value: 'Iranian', label: 'Iranian (Iran)' },
  { value: 'Iraqi', label: 'Iraqi (Iraq)' },
  { value: 'Irish', label: 'Irish (Ireland)' },
  { value: 'Israeli', label: 'Israeli (Israel)' },
  { value: 'Italian', label: 'Italian (Italy)' },
  { value: 'Jamaican', label: 'Jamaican (Jamaica)' },
  { value: 'Japanese', label: 'Japanese (Japan)' },
  { value: 'Jordanian', label: 'Jordanian (Jordan)' },
  { value: 'Kazakhstani', label: 'Kazakhstani (Kazakhstan)' },
  { value: 'Kenyan', label: 'Kenyan (Kenya)' },
  { value: 'I-Kiribati', label: 'I-Kiribati (Kiribati)' },
  { value: 'North Korean', label: 'North Korean (North Korea)' },
  { value: 'South Korean', label: 'South Korean (South Korea)' },
  { value: 'Kosovar', label: 'Kosovar (Kosovo)' },
  { value: 'Kuwaiti', label: 'Kuwaiti (Kuwait)' },
  { value: 'Kyrgyzstani', label: 'Kyrgyzstani (Kyrgyzstan)' },
  { value: 'Laotian', label: 'Laotian (Laos)' },
  { value: 'Latvian', label: 'Latvian (Latvia)' },
  { value: 'Lebanese', label: 'Lebanese (Lebanon)' },
  { value: 'Basotho', label: 'Basotho (Lesotho)' },
  { value: 'Liberian', label: 'Liberian (Liberia)' },
  { value: 'Libyan', label: 'Libyan (Libya)' },
  { value: 'Liechtensteiner', label: 'Liechtensteiner (Liechtenstein)' },
  { value: 'Lithuanian', label: 'Lithuanian (Lithuania)' },
  { value: 'Luxembourgish', label: 'Luxembourgish (Luxembourg)' },
  { value: 'Malagasy', label: 'Malagasy (Madagascar)' },
  { value: 'Malawian', label: 'Malawian (Malawi)' },
  { value: 'Malaysian', label: 'Malaysian (Malaysia)' },
  { value: 'Maldivian', label: 'Maldivian (Maldives)' },
  { value: 'Malian', label: 'Malian (Mali)' },
  { value: 'Maltese', label: 'Maltese (Malta)' },
  { value: 'Marshallese', label: 'Marshallese (Marshall Islands)' },
  { value: 'Mauritanian', label: 'Mauritanian (Mauritania)' },
  { value: 'Mauritian', label: 'Mauritian (Mauritius)' },
  { value: 'Mexican', label: 'Mexican (Mexico)' },
  { value: 'Moldovan', label: 'Moldovan (Moldova)' },
  { value: 'Monégasque', label: 'Monégasque (Monaco)' },
  { value: 'Mongolian', label: 'Mongolian (Mongolia)' },
  { value: 'Montenegrin', label: 'Montenegrin (Montenegro)' },
  { value: 'Moroccan', label: 'Moroccan (Morocco)' },
  { value: 'Mozambican', label: 'Mozambican (Mozambique)' },
  { value: 'Burmese', label: 'Burmese (Myanmar)' },
  { value: 'Namibian', label: 'Namibian (Namibia)' },
  { value: 'Nauruan', label: 'Nauruan (Nauru)' },
  { value: 'Nepali', label: 'Nepali (Nepal)' },
  { value: 'Dutch', label: 'Dutch (Netherlands)' },
  { value: 'New Zealander', label: 'New Zealander (New Zealand)' },
  { value: 'Nicaraguan', label: 'Nicaraguan (Nicaragua)' },
  { value: 'Nigerien', label: 'Nigerien (Niger)' },
  { value: 'Nigerian', label: 'Nigerian (Nigeria)' },
  { value: 'Macedonian', label: 'Macedonian (North Macedonia)' },
  { value: 'Norwegian', label: 'Norwegian (Norway)' },
  { value: 'Omani', label: 'Omani (Oman)' },
  { value: 'Pakistani', label: 'Pakistani (Pakistan)' },
  { value: 'Palauan', label: 'Palauan (Palau)' },
  { value: 'Panamanian', label: 'Panamanian (Panama)' },
  { value: 'Papua New Guinean', label: 'Papua New Guinean (Papua New Guinea)' },
  { value: 'Paraguayan', label: 'Paraguayan (Paraguay)' },
  { value: 'Peruvian', label: 'Peruvian (Peru)' },
  { value: 'Polish', label: 'Polish (Poland)' },
  { value: 'Portuguese', label: 'Portuguese (Portugal)' },
  { value: 'Qatari', label: 'Qatari (Qatar)' },
  { value: 'Romanian', label: 'Romanian (Romania)' },
  { value: 'Russian', label: 'Russian (Russia)' },
  { value: 'Rwandan', label: 'Rwandan (Rwanda)' },
  { value: 'Kittitian or Nevisian', label: 'Kittitian / Nevisian (Saint Kitts and Nevis)' },
  { value: 'Saint Lucian', label: 'Saint Lucian (Saint Lucia)' },
  { value: 'Vincentian', label: 'Vincentian (Saint Vincent and the Grenadines)' },
  { value: 'Samoan', label: 'Samoan (Samoa)' },
  { value: 'Sammarinese', label: 'Sammarinese (San Marino)' },
  { value: 'Sao Tomean', label: 'Sao Tomean (São Tomé and Príncipe)' },
  { value: 'Saudi', label: 'Saudi (Saudi Arabia)' },
  { value: 'Senegalese', label: 'Senegalese (Senegal)' },
  { value: 'Serbian', label: 'Serbian (Serbia)' },
  { value: 'Seychellois', label: 'Seychellois (Seychelles)' },
  { value: 'Sierra Leonean', label: 'Sierra Leonean (Sierra Leone)' },
  { value: 'Singaporean', label: 'Singaporean (Singapore)' },
  { value: 'Slovak', label: 'Slovak (Slovakia)' },
  { value: 'Slovene', label: 'Slovene / Slovenian (Slovenia)' },
  { value: 'Solomon Islander', label: 'Solomon Islander (Solomon Islands)' },
  { value: 'Somali', label: 'Somali (Somalia)' },
  { value: 'South African', label: 'South African (South Africa)' },
  { value: 'South Sudanese', label: 'South Sudanese (South Sudan)' },
  { value: 'Spanish', label: 'Spanish (Spain)' },
  { value: 'Sri Lankan', label: 'Sri Lankan (Sri Lanka)' },
  { value: 'Sudanese', label: 'Sudanese (Sudan)' },
  { value: 'Surinamese', label: 'Surinamese (Suriname)' },
  { value: 'Swedish', label: 'Swedish (Sweden)' },
  { value: 'Swiss', label: 'Swiss (Switzerland)' },
  { value: 'Syrian', label: 'Syrian (Syria)' },
  { value: 'Taiwanese', label: 'Taiwanese (Taiwan)' },
  { value: 'Tajikistani', label: 'Tajikistani (Tajikistan)' },
  { value: 'Tanzanian', label: 'Tanzanian (Tanzania)' },
  { value: 'Thai', label: 'Thai (Thailand)' },
  { value: 'Timorese', label: 'Timorese (Timor-Leste)' },
  { value: 'Togolese', label: 'Togolese (Togo)' },
  { value: 'Tongan', label: 'Tongan (Tonga)' },
  { value: 'Trinidadian or Tobagonian', label: 'Trinidadian / Tobagonian (Trinidad and Tobago)' },
  { value: 'Tunisian', label: 'Tunisian (Tunisia)' },
  { value: 'Turkish', label: 'Turkish (Turkey)' },
  { value: 'Turkmen', label: 'Turkmen (Turkmenistan)' },
  { value: 'Tuvaluan', label: 'Tuvaluan (Tuvalu)' },
  { value: 'Ugandan', label: 'Ugandan (Uganda)' },
  { value: 'Ukrainian', label: 'Ukrainian (Ukraine)' },
  { value: 'Emirati', label: 'Emirati (United Arab Emirates)' },
  { value: 'British', label: 'British (United Kingdom)' },
  { value: 'American', label: 'American (United States)' },
  { value: 'Uruguayan', label: 'Uruguayan (Uruguay)' },
  { value: 'Uzbekistani', label: 'Uzbekistani (Uzbekistan)' },
  { value: 'Ni-Vanuatu', label: 'Ni-Vanuatu (Vanuatu)' },
  { value: 'Vatican', label: 'Vatican (Vatican City)' },
  { value: 'Venezuelan', label: 'Venezuelan (Venezuela)' },
  { value: 'Vietnamese', label: 'Vietnamese (Vietnam)' },
  { value: 'Yemeni', label: 'Yemeni (Yemen)' },
  { value: 'Zambian', label: 'Zambian (Zambia)' },
  { value: 'Zimbabwean', label: 'Zimbabwean (Zimbabwe)' },
]
